<template>
    <v-navigation-drawer
        id="appDrawer"
        width="240"
        :mini-variant.sync="mini"
        fixed
        app
        v-model="drawer"
    >
        <v-toolbar color="grey lighten-5">
            <v-toolbar-title>NgConnectV2</v-toolbar-title>
        </v-toolbar>

        <vue-perfect-scrollbar
            class="drawer-menu--scroll"
            :settings="scrollSettings"         
        >
            <v-list dense expand>
                <template v-for="(item, i) in menus"    >   
                   <!--Dropdown effect -->
                    <!--group with subitems-->
                    <v-list-group
                        v-if="item.items"
                        class="navbar-list"
                        :key="item.name"
                        :group="item.group"
                        no-action="no-action"            
                    >
                        <template v-slot:activator>
                            <v-list-item-icon style="max-width: 25px">
                                <!-- <v-avatar size="30px">
                                  <img :src="`/images/icons/${item.icon}`">
                              </v-avatar> -->
                                <v-icon size="25px"> {{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="">{{
                                item.title
                            }}</v-list-item-title>
                        </template>

                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <v-list-group
                                v-if="subItem.items"
                                class=""
                                :key="subItem.name"
                                :group="subItem.group"
                                sub-group="sub-group"
                            >
                                <v-list-item
                                    active-class="secondary--text"
                                    slot="activator"
                                    ripple="ripple"
                                >
                                    <v-list-item-content class="">
                                        <v-list-item-title>{{
                                            subItem.title
                                        }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    active-class="secondary--text"
                                    v-for="(grand, i) in subItem.children"
                                    :key="i"
                                    :to="{ name: grand.route }"
                                    ripple="ripple"
                                >
                                    <v-list-item-content class="">
                                        <v-list-item-title>{{
                                            grand.title
                                        }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                            <!--child item-->
                            <v-list-item
                                active-class="secondary--text"
                                class=""
                                v-else
                                :key="i"
                                :to="{ name: subItem.route }"
                                :disabled="subItem.disabled"
                                :target="subItem.target"
                                ripple="ripple"
                            >
                                <v-list-item-content class="">
                                    <v-list-item-title
                                        ><span>{{
                                            subItem.title
                                        }}</span></v-list-item-title
                                    >
                                </v-list-item-content>
                                <v-list-item-action v-if="subItem.action">
                                    <v-icon
                                        :class="[
                                            subItem.actionClass ||
                                                'success--text',
                                        ]"
                                        >{{ subItem.action }}</v-icon
                                    >
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list-group>
                    <!--------->
                    <!-- <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider> -->
                    <!--top-level link-->
                    
                    <!-- No Dropdown -->
                    <v-list-item
                       v-if="item.permission.includes(getrole)"
                        class="navbar-list"
                        active-class="secondary--text"
                        :to="{ name: item.route }"
                        ripple="ripple"
                        :disabled="item.disabled"
                        :target="item.target"
                        rel="noopener"
                        :key="item.name"
                    >
                        <v-list-item-icon
                            v-if="item.icon"
                            style="max-width: 25px"
                        >
                            <!-- <v-avatar size="30px">
                              <img :src="`/images/icons/${item.icon}`">
                          </v-avatar> -->
                            <v-icon size="25px"> {{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="">
                            <v-list-item-title>{{
                                item.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.subAction">
                            <v-icon class="success--text">{{
                                item.subAction
                            }}</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>
<script>
import { Menu, SecuritySetup } from "@/components/core/_nav.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    name: "app-drawer",
    components: {
        VuePerfectScrollbar,
    },
    props: {
        expanded: {
            type: Boolean,
            default: true,
        },
        drawer: {
            type: Boolean,
            default: true,
        },
        getrole:null,      
    },
    data() {
        return {
            accessType: {
                firstTime: false,
                trade: true,
                register: true,
            },
            mini: false,
            menus: SecuritySetup,
            scrollSettings: {
                maxScrollbarLength: 160,
            },
      
            token: null,
            roles:null, 
        };
    },

   async created() {
        // this.form.id_user = this.$route.params.id;
        this.accessType.admin = true;
        this.accessType.operation = true;
        this.initializeMenu();
        // console.log('get'+this.getrole)
      

       
      
    },
    methods: {
        initializeMenu() {
            this.menus = Menu;
        },
     
        checkAccessPermission(accessArr) {
            if (!accessArr )
            { return false;}
            let self = this;
            for (var i = 0; i < accessArr.length; i++) {
                if (self.accessType[`${accessArr[i]}`] == true) {
                    return true;
                   
                }
            }
            return false;
        },
    },
    computed: {
        computeGroupActive() {
            return true;
        },
        computeLogo() {
            return "/static/m.png";
        },

  
        

    },
    // async created() {
    //     //await this.getUserData();

    //     //TODO get permission from db

    //     //this.accessType.admin = (this.role == 1 || this.role == 5) ? true:false;
    //     //this.accessType.operation = this.role == 3 ? true:false;

      
    //     // window.getApp.$on('APP_DRAWER_TOGGLED', () => {
    //     //   this.drawer = (!this.drawer);
    //     // });
    // },
};
</script>
